import { useNavigate } from "react-router-dom";

import { useTranslationContext } from 'hooks';

import classes from './LanguagePicker.module.scss';

export default function LanguagePicker() {
  const { supportedLanguages, setLanguage } = useTranslationContext();
  const navigate = useNavigate();

  const handleLanguageChange = (language: string) => {
    const replacePath = (pathname: string, languageCode: string) => `/${pathname.split('/')[1]}/${languageCode}`;

    navigate(replacePath(window.location.pathname, language) + window.location.search, { replace: true });
    setLanguage(language);
  }

  return (
    <div className={classes.LanguagePicker}>
      {supportedLanguages.map(language => (
        <button
          key={language}
          type="button"
          onClick={() => handleLanguageChange(language)}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
